import { Injectable } from '@angular/core';

@Injectable()
export class ConfigurationService<T> {
  configuration!: T & { version?: string };

  load(path: string): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      this.configuration = {} as T & { version?: string };
      const request = new XMLHttpRequest();
      request.onreadystatechange = (): void => {
        if (request.readyState === 4 && request.status === 200) {
          try {
            this.configuration = JSON.parse(request.response);
            return resolve(this.configuration);
          } catch {
            return reject('Cannot fetch the configuration');
          }
        } else if (request.readyState === 4) {
          return reject('Cannot fetch the configuration');
        }
      };
      request.open('GET', path);
      request.send();
    });
  }

  loadAppVersion(version: string): void {
    this.configuration.version = version;
  }
}
